import React, { useState } from 'react';
import { FaBars, FaTimes, FaStar, FaSearch, FaMapMarkerAlt, FaArrowRight, FaApple, FaGooglePlay } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './bp.module.css';

// Placeholder images - replace with actual images
const heroBackground = '/placeholder-hero-bg.jpg';
const buildingImage = '/placeholder-building.jpg';
const aiSectionImage = '/placeholder-ai-workers.jpg';
const appMockup = '/placeholder-app-mockup.png';
const logoImage = '/placeholder-logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img
            src={logoImage}
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}
          />
          <span className="logo-text">Build Start</span>
        </div>
        <nav className={`nav ${isMenuOpen ? 'nav-mobile-open' : ''}`}>
          <ul className="nav-links">
            <li className="close-icon" onClick={toggleMenu}><FaTimes /></li>
            <li><a href="/">Home Owner</a></li>
            <li className="active-link"><a href="/business-landing">For Building Professionals</a></li>
            <li><a href="/for-developers">For Renovators / Developers</a></li>
            <li><a href="/resources-hub">Resource Hub</a></li>
            <li><a href="/contact-support">Support</a></li>
            <li className="mobile-auth">
              <Link to="/login" className="btn-login">Login</Link>
            </li>
            <li className="mobile-auth">
              <Link to="/select-role" className="btn-register">Register</Link>
            </li>
          </ul>
        </nav>
        <div className="header-right">
          <Link to="/login" className="btn-login">Login</Link>
          <Link to="/select-role" className="btn-register">Register</Link>
        </div>
        <div className="menu-icon" onClick={toggleMenu}>
          <FaBars />
        </div>
      </div>
    </header>
  );
};

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="rating-badge">
          <div className="stars">
            <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
          </div>
          <span>4.9 Rated, 200+ Reviews</span>
        </div>
        <h1 className="hero-title">
          LET QUALITY LEADS<br />COME TO YOU
        </h1>
        <p className="hero-subtitle">
          Build Start is an invitation only directory of the most trusted professionals
          in your area. We connect you with serious homeowners, ready to hire.
        </p>
        <div className="search-box">
          <input
            type="text"
            placeholder="E.g. Plumber, Electrician, Surveyor"
            className="search-input"
          />
          <button className="search-btn">
            <FaSearch /> Search
          </button>
        </div>
        <div className="hero-buttons">
          <button className="btn-primary-hero">Post a Job</button>
          <button className="btn-secondary-hero">Connect using our Social Network</button>
        </div>
      </div>
    </section>
  );
};

const ConnectSection = () => {
  return (
    <section className="connect-section">
      <div className="connect-container">
        <div className="connect-image">
          <img src={buildingImage} alt="Modern Building" />
        </div>
        <div className="connect-content">
          <h2>
            CONNECT WITH MORE<br />
            <span className="text-primary">LOCAL CLIENTS</span>
          </h2>
          <p>
            List your business on Building Start and get booked for jobs.
            Posted by local clients.
          </p>
          <div className="connect-buttons">
            <button className="btn-primary">List your Business Today</button>
            <button className="btn-outline">Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

const AISection = () => {
  return (
    <section className="ai-section">
      <div className="ai-container">
        <div className="ai-image">
          <img src={aiSectionImage} alt="AI Powered Platform" />
        </div>
        <div className="ai-content">
          <h2>
            LEVERAGE THE<br />
            <span className="text-primary">POWER OF</span>
            <span className="ai-badge">AI</span>
          </h2>
          <p>
            Experience the industry's first AI Powered platform to
            promote your business, match you with most relevant
            clients and help manage your workflows and jobs.
          </p>
        </div>
      </div>
    </section>
  );
};

const AvailableJobsSection = () => {
  const jobs = [
    {
      icon: '📐',
      title: 'Architect',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      location: '24998 Brighton Lane, Lake Forest, CA 92630.',
    },
    {
      icon: '⚡',
      title: 'Electrician',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      location: '24998 Brighton Lane, Lake Forest, CA 92630.',
    },
    {
      icon: '❄️',
      title: 'Air conditioning',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      location: '24998 Brighton Lane, Lake Forest, CA 92630.',
    },
  ];

  return (
    <section className="jobs-section">
      <div className="jobs-container">
        <div className="jobs-header">
          <div>
            <h2>Available jobs</h2>
            <p>Someone just posted these jobs in your area. Don't miss out!</p>
          </div>
          <button className="btn-primary">
            Browse more jobs <FaArrowRight />
          </button>
        </div>
        <div className="jobs-grid">
          {jobs.map((job, index) => (
            <div key={index} className="job-card">
              <div className="job-icon">{job.icon}</div>
              <h3>{job.title}</h3>
              <p>{job.description}</p>
              <div className="job-location">
                <FaMapMarkerAlt />
                <span>{job.location}</span>
                <FaArrowRight className="arrow" />
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-dots">
          <span className="dot active"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </section>
  );
};

const HowItWorksSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Register your account',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry.',
    },
    {
      number: '02',
      title: 'Search your job',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry.',
    },
    {
      number: '03',
      title: 'Hire or post your job',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry.',
    },
    {
      number: '04',
      title: 'Get your job done',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry.',
    },
  ];

  return (
    <section className="how-it-works-section">
      <div className="how-container">
        <div className="how-content">
          <h2>How It Works</h2>
          <p className="how-subtitle">working a piece of Build Start...</p>
          <div className="steps-list">
            {steps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-number">{step.number}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="how-image">
          <div className="image-placeholder">
            <div className="quality-badge">
              Proof of quality<br />same as food leve
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const AppDownloadSection = () => {
  return (
    <section className="app-section">
      <div className="app-container">
        <div className="app-content">
          <h2>
            Download the Build Start<br />
            app <span className="text-accent">to stay connected</span>
          </h2>
          <p>Get a better view of what you both want.</p>
          <div className="app-buttons">
            <button className="store-btn apple">
              <FaApple />
              <div>
                <span className="small">Download on the</span>
                <span className="large">App Store</span>
              </div>
            </button>
            <button className="store-btn google">
              <FaGooglePlay />
              <div>
                <span className="small">GET IT ON</span>
                <span className="large">Google Play</span>
              </div>
            </button>
          </div>
        </div>
        <div className="app-mockup">
          <div className="mockup-container">
            <div className="phone-mockup"></div>
            <div className="stats-badge">+75%</div>
          </div>
        </div>
      </div>
    </section>
  );
};

const TestimonialsSection = () => {
  const testimonials = [
    {
      text: '"Lorem consectetur at amet, consectetur adipiscing elit, sed do eiusmod tempore Incididunt ut labore et dolore magna aliqua. Ut enim minim Suscipit non, aliquip."',
      name: 'JHONE DEO',
      role: 'Business Owner, Cambridge',
    },
    {
      text: '"Lorem consectetur at amet, consectetur adipiscing elit, sed do eiusmod tempore Incididunt ut labore et dolore magna aliqua. Ut enim minim Suscipit non, aliquip."',
      name: 'JHONE DEO',
      role: 'Business Owner, Cambridge',
    },
    {
      text: '"Lorem consectetur at amet, consectetur adipiscing elit, sed do eiusmod tempore Incididunt ut labore et dolore magna aliqua. Ut enim minim Suscipit non, aliquip."',
      name: 'JHONE DEO',
      role: 'Business Owner, Cambridge',
    },
    {
      text: '"Lorem consectetur at amet, consectetur adipiscing elit, sed do eiusmod tempore Incididunt ut labore et dolore magna aliqua. Ut enim minim Suscipit non, aliquip."',
      name: 'JHONE DEO',
      role: 'Business Owner, Cambridge',
    },
    {
      text: '"Lorem consectetur at amet, consectetur adipiscing elit, sed do eiusmod tempore Incididunt ut labore et dolore magna aliqua. Ut enim minim Suscipit non, aliquip."',
      name: 'JHONE DEO',
      role: 'Business Owner, Cambridge',
    },
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="stars-row">
            <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
            <span>4.9 Rated 200+ Reviews</span>
          </div>
          <h2>
            HEAR WHAT THOUSANDS<br />
            OF OUR USERS <span className="text-accent">THINK ABOUT US</span>
          </h2>
          <p>
            Read about Experiences of our users and see how we can connect you with
            The TOP Professionals in Town.
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="card-stars">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
              </div>
              <p>{testimonial.text}</p>
              <div className="testimonial-author">
                <div className="author-avatar"></div>
                <div className="author-info">
                  <span className="author-name">{testimonial.name}</span>
                  <span className="author-role">{testimonial.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-dots">
          <span className="dot active"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <div className="footer-logo">
            <span className="logo-icon">🏗️</span>
            <span>Build Start</span>
          </div>
          <p>A Nevin Pty Ltd Platform</p>
          <div className="social-links">
            <a href="#">𝕏</a>
            <a href="#">📷</a>
            <a href="#">in</a>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#">For Home Owners</a></li>
              <li><a href="#">Find Specialists</a></li>
              <li><a href="#">Jobs</a></li>
              <li><a href="#">Professionals</a></li>
              <li><a href="#">Prices</a></li>
              <li><a href="#">Advertising/Pricing</a></li>
              <li><a href="#">Contact</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Directory</h4>
            <ul>
              <li><a href="#">Advertisement</a></li>
              <li><a href="#">Locations</a></li>
              <li><a href="#">Categories</a></li>
              <li><a href="#">For Pros</a></li>
              <li><a href="#">Estimators</a></li>
              <li><a href="#">Contractors</a></li>
              <li><a href="#">Add Bus</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Resources</h4>
            <ul>
              <li><a href="#">Partnerships</a></li>
              <li><a href="#">News & Blog</a></li>
              <li><a href="#">Design Tips</a></li>
              <li><a href="#">HowTo</a></li>
              <li><a href="#">Support</a></li>
              <li><a href="#">Case Reviews</a></li>
              <li><a href="#">Resource Library</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 BUILD START - All Publishing Disclaimer | Terms And Conditions | Privacy Policy</p>
      </div>
    </footer>
  );
};

const BusinessLandingFormat = () => {
  return (
    <div className="business-landing">
      <Header />
      <HeroSection />
      <ConnectSection />
      <AISection />
      <AvailableJobsSection />
      <HowItWorksSection />
      <AppDownloadSection />
      <TestimonialsSection />
      <Footer />
    </div>
  );
};

export default BusinessLandingFormat;
